import { URLS } from '@/data';
import { useUserStore } from '@/hooks/use-user-store';
import { PlayerInsightsResponse } from '@/types/openapi.generated';
import { useQuery } from '@tanstack/react-query';

const fetchPlayerInsights = async ({ playerId }: GetPlayerInsightsQueryParams): Promise<PlayerInsightsResponse> => {
    const response = await fetch(`${URLS.FANTASY_REST_API_URL}/players/${playerId}/insights`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: useUserStore.getState().session?.access_token ?? '',
        },
    });
    const data = await response.json();
    if (!response.ok) {
        throw data;
    }

    return data;
};

export type GetPlayerInsightsQueryParams = {
    playerId: string;
};

export const usePlayerInsights = (params: GetPlayerInsightsQueryParams) => {
    return useQuery({
        queryKey: ['player-insights', params.playerId],
        queryFn: () => fetchPlayerInsights(params),
        refetchOnWindowFocus: false,
        staleTime: 60 * 60 * 1000, // 1 hour
    });
};
